import { render, staticRenderFns } from "./PartnersCustomBlock.vue?vue&type=template&id=3619ea88"
import script from "./PartnersCustomBlock.vue?vue&type=script&lang=js"
export * from "./PartnersCustomBlock.vue?vue&type=script&lang=js"
import style0 from "./PartnersCustomBlock.vue?vue&type=style&index=0&id=3619ea88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports